import { render, staticRenderFns } from "./AccommodationReport.vue?vue&type=template&id=51113028&"
import script from "./AccommodationReport.vue?vue&type=script&lang=ts&"
export * from "./AccommodationReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports